import { object } from 'yup'
import { DonorInfoFormData } from '../components/donor-info-fields'
import { makeOrderContactValidationSchema } from 'modules/order/state/contact/contact-utils'
import { makeOrderAddressValidationSchema } from 'modules/order/state/address/address-utils'

export const makeDonorInfoValidationSchema = () => {
  // Reuse existing validation schemas
  const contactSchema = makeOrderContactValidationSchema(false) // phone not required
  const addressSchema = makeOrderAddressValidationSchema()

  return object({
    // From contact: email, firstName, lastName
    email: contactSchema.fields.email,
    firstName: contactSchema.fields.firstName,
    lastName: contactSchema.fields.lastName,

    // From address: country, zipCode
    country: addressSchema.fields.country,
    zipCode: addressSchema.fields.zipCode,
  })
}

// Default values for the form
export const makeDonorInfoDefaultValues = (): DonorInfoFormData => ({
  email: '',
  firstName: '',
  lastName: '',
  country: 'US', // Default to US
  zipCode: '',
})
